import {$} from "../constants";
import "../../../dependencies/node_modules/magnific-popup";

export default function Popups() {
    $('.video-popup').magnificPopup({
        type: 'iframe'
    });
}
